import {Component} from "@angular/core";
import {ActivatedRoute, Router} from "@angular/router";
import {WorkflowService} from "../workflow.service";
import {DeviceService} from "../../device/device.service";
import {AssetRemovalService} from "../../asset/asset-removal.service";
import {WorkflowTargetInfoModel} from "../models/workflow-target-info.model";
import {WorkflowStepStatus} from "../models/workflow-step-status.enum";
import {DialogService} from "../../bootstrap-modal/dialog.service";
import {WorkflowStep} from "../workflow-step";
import {ConfirmDialogService} from "../../confirm-dialog/confirm-dialog-service";
import {handleErrors} from "../../misc/handle-errors.decorator";
import {toggleLoading} from "../../misc/loading.decorator";
import {SiteDesignService} from "../../site-design/site-design.service";
import {SiteService} from "../../sites/site.service";
import {AccessoryService} from "../../accessory/accessory.service";
import {get} from "lodash";
import _ = require("lodash");
import {AssetForSiteDesignModel} from "../../asset/asset-for-site-design.model";
import {ImportCdfDialogComponent} from "./import-cdf-dialog.component";
import {AddIndividualAssetsDialogComponent} from "./add-individual-assets-dialog.component";
import {AssetService, AssetDataValidationModel} from "../../asset/asset.service";
import {AssetGqlModel, AssetAvailableDeviceModel} from "../../asset/asset.gql-model";
import {StandaloneAccessoryGqlModel} from "../../accessory/standalone-accessory.gql-model";
import {SoftwareGqlModel, SoftwareInputDataGqlModel} from "../../software/software.gql-model";
import {SiteWorkflowService} from "./site-workflow.service";
import {DropdownsModel, ListSiteGroupModel, SiteContactsModel, PurchaseOrderModel, SiteContractModel} from "./assets-dropdowns-info-model";
import {ItsmAddressModel, itsmSettableAddressesModelFactory, ItsmSiteSettableAddressesModel} from "../../address/itsm-address.model";
import {ItsmContactModel} from "../../contact/itsm-contact.model";
import {MultiError} from "../../errors/multi-error";
import {DartCorrectionRequestDialogComponent} from "./dart-correction-request";
import {SelectAssetAssociationDialogComponent} from "../../asset/select-asset-association-dialog.component";
import {DataFromEditAccessoryModel} from "../../asset/edit-asset.component";
import {ProjectService} from "../../project/project.service";
import {ProjectModel} from "../../project/project.model";
import {CostCenterService} from "../../cost-center/cost-center.service";
import {CostCenterModel} from "../../cost-center/cost-center.model";
import {AppSettingsService} from "../../app-settings/app-settings.service";
import {BillFromService} from "../../bill-from/bill-from.service";
import {BillFromValue} from "../../bill-from/bill-from-with-region.model";
import {HasuraGraphqlService} from "../../graphql/hasura-graphql-service";
import {Query} from "../../graphql/query-constant";
import { TARGET_SYSTEM } from "../../helpers/app-constants";
import { masterAgreementStatusValues } from "../../project/master-agreement-status";
import {DisGqlModel, DisInputDataGqlModel} from "../../dis/dis.gql-model";

export interface DataFromEditAssetModel {
  asset: AssetGqlModel;
  changes: boolean;
}

const DEFAULT_PAGE = 1;
const DEFAULT_PAGE_LIMIT = 10;

@Component({
  templateUrl: "./individual-site-design.template.pug",
  providers: [
    AssetService,
    DeviceService,
    AssetRemovalService,
    AccessoryService,
    DialogService,
    ConfirmDialogService,
    SiteDesignService,
    SiteWorkflowService,
    SiteService,
    BillFromService,
    HasuraGraphqlService
  ],
})
export class IndividualSiteDesignComponent extends WorkflowStep {
  public projectId: string;
  public siteId: string;
  public devices: any[] = [];
  public assets: AssetForSiteDesignModel[] = [];
  public currentPage: number = DEFAULT_PAGE;
  public pageSize: number = DEFAULT_PAGE_LIMIT;
  public maxPages: number = 0;
  public totalCount: number = 0;
  public searchText: string = "";
  public error: Error;
  public stepName: string = "";
  public targetId: string;
  public targetSystem: string;
  // public loading: boolean = true;
  public selectedIndex: number = -1;
  public currentAsset: AssetGqlModel = new AssetGqlModel({});
  public currentAssetChanged: AssetGqlModel = new AssetGqlModel({});
  public currentDevice: AssetAvailableDeviceModel = new AssetAvailableDeviceModel({});
  public currentAccessory: StandaloneAccessoryGqlModel = new StandaloneAccessoryGqlModel({});
  public currentSoftware: SoftwareGqlModel = new SoftwareGqlModel({});
  public groupList: ListSiteGroupModel[];
  public siteContract: SiteContractModel[];
  public siteContactsList: SiteContactsModel[];
  public purchasOrdersList: PurchaseOrderModel[];
  public dropdowns: DropdownsModel;
  public assetOpened: boolean = false;
  public assetChanged: boolean = false;
  public successfulSave: boolean = false;
  public itsmAddressInfo: ItsmSiteSettableAddressesModel;
  public settableAddressesWithItsmBuildingIds: ItsmAddressModel[] = []; // Only send these addresses to the dialog
  public settableAddresses: ItsmAddressModel[] = [];
  public itsmSiteContacts: ItsmContactModel[] = [];
  public itsmContractAccount: {"cId": string, "name": string} [] = [];
  public billFromAccounts: BillFromValue[];
  public itsmSiteContactsWithItsmId: ItsmContactModel[] = [];
  public currentDeviceType: string = "";
  public softwareSaved: boolean = false;
  POR954_TMC: boolean;
  public letAddNewAsset: boolean = true;
  public devicesAssoc: any = {};
  public itsmCustomerId: string = "";
  public costCenters: CostCenterModel[] = [];
  processing: boolean = false;
  processingAsset: boolean = false;
  accountDetails;
  public itsmCustomInformation;
  public enableCustomFieldsFlag: boolean = false;
  public CR923: boolean = false;
  public enableMultipleCA: boolean = false;
  public showBillFrom: boolean = false;
  isFileDownloading = false;
  public enableAssetColorsFlag: boolean = false;
  public enablePOR0241: boolean = false;
  public enableBillFrom = false;

  public assetAssociations = {
    accessories: 0,
    software: 0,
  };

  public project: ProjectModel;
  public assetTypes = {
    asset: "Device",
    accessory: "Accessory",
    software: "Software",
    independentService: "Device Independent Service",
  };

  public defaultContacts = {
    serviceAddressId: null,
    tonerAddressId: null,
  };

  ContractualContactTypes: any = {
    billTo: [],
    accDelMgr: [],
    contractAdmin: [],
    hpInvoice: [],
    sales: [],
    invoice: [],
  };
  itsmContacts: any = [];
  itsmContactsWithItsmIds: any [];
  itsmContactsWithBpId: any = [];
  nonHpItsmContactsWithBpId: any = [];
  itsmContactsWithBpIdMap: any = {};
  por731: boolean;
  currentDis: DisGqlModel = new DisGqlModel({});
  disSaved: boolean;

  constructor(
    public route: ActivatedRoute,
    public router: Router,
    public workflowService: WorkflowService,
    private dialogService: DialogService,
    private siteDesignService: SiteDesignService,
    private confirmDialogService: ConfirmDialogService,
    public assetService: AssetService,
    public siteWorkflowService: SiteWorkflowService,
    public siteService: SiteService,
    public accessoryService: AccessoryService,
    private projectService: ProjectService,
    private costCenterService: CostCenterService,
    private appSettingsService: AppSettingsService,
    private billFromService: BillFromService,
    private hasuraGqlService: HasuraGraphqlService,
  ) {
    super();
  }

  @handleErrors()
  async autoSave(): Promise<boolean> {
    const assetChanges = {
      asset: this.currentAssetChanged,
      changes: this.assetChanged,
    };
    await this.save(assetChanges);
    if (!this.successfulSave) return false;

    await this.workflowService.setStepStatus(WorkflowStepStatus.Completed);

    return true;
  }

  @toggleLoading()
  @handleErrors()
  async ready(workflowTargetInfo: WorkflowTargetInfoModel) {
    this.loading = true;
    this.projectId = workflowTargetInfo.projectId;
    this.siteId = workflowTargetInfo.targetId;
    this.targetId = this.workflowService.workflowConfig.targetId;
    this.targetSystem = this.workflowService.workflowConfig.targetSystem;
    this.stepName = get(this.workflowService.currentStep, "stepName");
    this.workflowService.setStepStatus(WorkflowStepStatus.InProgress, workflowTargetInfo.stepName);

    // await this.loadData();
    await this.loadItsmData();

    this.assets.forEach((a) => {
      if (a.type !== "asset" && a.assetId) {
        this.setDeviceAssociation(a);
      }
    });


    // if (enableApolloProjectQuery) {
    //   const params: any = `
    //     id
    //     itsmCustomerId
    //     purchaseOrderSplit
    //     billFromStructure
    //     countryId
    //   `;

    //   this.project = await this.projectService.getProjectDetails(this.projectId, params);
    // } else {
    //   this.project = await this.projectService.getProjectById(this.workflowService.workflowConfig.projectId).toPromise();
    // }
    const params: any = `
    id
    itsmCustomerId: itsm_customer_id
    purchaseOrderSplit: purchase_order_split
    billFromStructure: bill_from_structure
    countryId: country_id`;
    this.project = await this.hasuraGqlService.getProjectResponseFromHasura(this.projectId, params);
    this.showBillFrom = await this.billFromService.showBillFrom(this.project) &&
      this.billFromService.isDecentralized(this.project);
    if (this.showBillFrom) {
      await this.loadBillFromBuildings();
    }

    this.itsmCustomerId = this.project.itsmCustomerId;
    this.loading = false;
  }

  @handleErrors()
  async loadData() {
    if (!this.siteId) {
      this.error = new Error("Site not found");
      return;
    }
    this.error = undefined;

    const [
      assetList,
      dropDownList,
    ] = await Promise.all([
      this.siteDesignService.getCurrentSiteDesign(
        `${+(this.currentPage) - 1}`,
        `${+(this.pageSize)}`,
        this.searchText,
        this.siteId,
      ),
      this.siteWorkflowService.getAssetsDropdownData(this.siteId, this.projectId),
    ]);

    const {rows, count} = assetList;

    this.assets = rows;
    this.maxPages = Math.ceil(count / (+this.pageSize));
    this.totalCount = count;
    this.processingAsset = false;
    await this.clearAndCloseCurrentAsset();

    const {
      dropdownGroupsList,
      dropdowns,
      dropdownSiteContacts,
      dropdownPurchaseOrders,
      dropdownContractList,
    } = dropDownList;
    this.groupList = dropdownGroupsList;
    this.siteContactsList = dropdownSiteContacts;
    this.purchasOrdersList = dropdownPurchaseOrders;
    this.dropdowns = dropdowns;
    this.siteContract = dropdownContractList;
    this.softwareSaved = false;
  }

  @handleErrors()
  async loadItsmData() {
    if (!this.siteId) {
      this.error = new Error("Site not found");
      return;
    }
    Query.INDIVIDUAL_SITE_DESIGN.variables.siteId = this.siteId;
    const queryParam = {
      projectId: this.projectId,
      query: Query.INDIVIDUAL_SITE_DESIGN,
      uiAction: "INDIVIDUAL-SITE-ITSM-ADDRESS",
    };
    Query.GLOBAL_OPP_ID.variables.projectId = this.projectId;
    const contactParams = {
      projectId: this.projectId,
      uiAction: "SITE-CONTACT",
      queryType: "Global-Deal",
      query: Query.GLOBAL_OPP_ID,
    };
    Query.PROJECT_SITES.variables.projectId = this.projectId;
    const projectSitesQuery = {
      projectId: this.projectId,
      uiAction: "PROJECT-SITES",
      query: Query.PROJECT_SITES,
    };
    let multipleCA;
    let POR024;
    let itsmAddressInfo;
    let assets;
    let assetDropDown;
    let tmcProjectIndividualPage;
    let POR89_2_flag = false;
    let POR89_2_TMC_flag = false;
    let POR024_1 = false;
    let contactResponse;
    let enableBillFrom;
    let projectSites;
    let featurePermissions;
    let por731 = false;
    
    [
      featurePermissions,
      contactResponse,
      tmcProjectIndividualPage,
      assets,
      assetDropDown,
      projectSites,
    ] = await Promise.all([
      
      this.appSettingsService.getFeaturePermissionsList(["enableMultipleCA", "POR024", "enableCustomFields", "CR923_COA_TMC", "POR89-2", "POR89-2_TMC", "POR024_1", "enableBillFrom", "POR731_TMC"]),
      // this.siteService.getItsmContacts(this.siteId),
      this.hasuraGqlService.getResponseFromHasura(contactParams),
      // this.siteService.getItsmSettableAddresses(this.siteId),
      // this.costCenterService.getCostCentersByProjectId(this.projectId),
      this.hasuraGqlService.getResponseFromHasura(queryParam),
      this.siteDesignService.getCurrentSiteDesign(
        `${+(this.currentPage) - 1}`,
        `${+(this.pageSize)}`,
        this.searchText,
        this.siteId,
      ),
      this.siteWorkflowService.getAssetsDropdownData(this.siteId, this.projectId),     
      this.hasuraGqlService.getResponseFromHasura(projectSitesQuery),
      this.loadFinancialContact(),
    ]);
    [
      multipleCA,
      POR024,
      this.enableCustomFieldsFlag,
      this.CR923,      
      POR89_2_flag,
      POR89_2_TMC_flag,
      POR024_1,
      enableBillFrom,
      por731,
    ]=[
      featurePermissions["enableMultipleCA"],
      featurePermissions["POR024"],
      featurePermissions["enableCustomFields"],
      featurePermissions["CR923_COA_TMC"],
      featurePermissions["POR89-2"],
      featurePermissions["POR89-2_TMC"],
      featurePermissions["POR024_1"],
      featurePermissions["enableBillFrom"],
      featurePermissions["POR731_TMC"],
    ];

    const itsmSiteIds = projectSites.body.data.site.map(site => site.address.siteId);
    this.enableAssetColorsFlag = POR89_2_flag || POR89_2_TMC_flag;
    this.enableBillFrom = enableBillFrom;
    if (tmcProjectIndividualPage && tmcProjectIndividualPage.body.data.site.length > 0 &&
      tmcProjectIndividualPage.body.data.site[0].project &&
      tmcProjectIndividualPage.body.data.site[0].project.global_deal_settings &&
      tmcProjectIndividualPage.body.data.site[0].project.global_deal_settings.length > 0) {
      this.costCenters = tmcProjectIndividualPage.body.data.site[0].project.global_deal_settings[0].projectCostCenter ?
        tmcProjectIndividualPage.body.data.site[0].project.global_deal_settings[0].projectCostCenter.cost_centers : [];
    }
    this.enableMultipleCA = multipleCA && POR024;
    this.enablePOR0241 = POR024_1;
    this.por731 = por731;
    const {rows, count} = assets;
    this.assets = rows;
    this.maxPages = Math.ceil(count / (+this.pageSize));
    this.totalCount = count;
    this.processingAsset = false;
    await this.clearAndCloseCurrentAsset();
    const {
      dropdownGroupsList,
      dropdowns,
      dropdownSiteContacts,
      dropdownPurchaseOrders,
      dropdownContractList,
    } = assetDropDown;
    this.groupList = dropdownGroupsList;
    this.siteContactsList = dropdownSiteContacts;
    this.purchasOrdersList = dropdownPurchaseOrders;
    this.dropdowns = dropdowns;
    this.siteContract = dropdownContractList;
    this.softwareSaved = false;
    if (this.enableCustomFieldsFlag && tmcProjectIndividualPage &&
      tmcProjectIndividualPage.body.data.site.length > 0 &&
      tmcProjectIndividualPage.body.data.site[0].project &&
      tmcProjectIndividualPage.body.data.site[0].project.customHeaders) {
      const labelValues = tmcProjectIndividualPage.body.data.site[0].project.customHeaders || {};
      delete labelValues.customTransactionId;
      const customLabelArray = [];
      const keys = Object.keys(labelValues);
      for (let i = 0; i < keys.length; i++) {
        const key = keys[i];
        customLabelArray.push({number: i + 1, value: labelValues[key]});
      }
      this.itsmCustomInformation = customLabelArray;
    }
    if (tmcProjectIndividualPage && tmcProjectIndividualPage.body && tmcProjectIndividualPage.body.data &&
      tmcProjectIndividualPage.body.data.site && tmcProjectIndividualPage.body.data.site.length > 0) {
      const itsmSiteId = tmcProjectIndividualPage.body.data.site[0].address.siteId;
      Query.MPC_SITE_ADDRESS.variables.siteId = itsmSiteIds;
      const settableAddressParams = {
        projectId: this.projectId,
        query: Query.MPC_SITE_ADDRESS,
        uiAction: "INDIVIDUAL-SITE-ITSM-ADDRESS",
      };
      const addressResponse = await this.hasuraGqlService.getResponseFromHasura(settableAddressParams);
      if (addressResponse.body.data.settableAddresses &&
        addressResponse.body.data.settableAddresses.length > 0) {
        let siteAddress: ItsmSiteSettableAddressesModel = {
          physicalAddressId: tmcProjectIndividualPage.body.data.site[0].physicalAddressId,
          tonerAddressId: tmcProjectIndividualPage.body.data.site[0].tonerAddressId,
          serviceAddressId: tmcProjectIndividualPage.body.data.site[0].serviceAddressId,
          hpInstalledKit: tmcProjectIndividualPage.body.data.site[0].hpInstalledKit,
          tmcSiteName: tmcProjectIndividualPage.body.data.site[0].tmcSiteName,
          defaultCustomShippingLabel1: tmcProjectIndividualPage.body.data.site[0].project ?
            tmcProjectIndividualPage.body.data.site[0].project.defaultCustomShippingLabel1 : "",
          defaultCustomShippingLabel2: tmcProjectIndividualPage.body.data.site[0].project ?
            tmcProjectIndividualPage.body.data.site[0].project.defaultCustomShippingLabel2 : "",
          itsmSiteAddressId: itsmSiteId,
          itsmSiteName: tmcProjectIndividualPage.body.data.site[0].project.settableAddresses &&
              tmcProjectIndividualPage.body.data.site[0].project.settableAddresses.length > 0 ?
            tmcProjectIndividualPage.body.data.site[0].project.settableAddresses[0].itsmSiteName : "",
          settableAddresses: addressResponse.body.data.settableAddresses,
        };
        siteAddress = itsmSettableAddressesModelFactory(siteAddress);
        this.itsmAddressInfo = siteAddress;
        this.settableAddresses = siteAddress.settableAddresses;
        this.defaultContacts.serviceAddressId = siteAddress.serviceAddressId;
        this.defaultContacts.tonerAddressId = siteAddress.tonerAddressId;
      }
    }

    let contacts = contactResponse && contactResponse.body && contactResponse.body.data &&
      contactResponse.body.data.contacts && contactResponse.body.data.contacts.length > 0 ?
      contactResponse.body.data.contacts : [];
    contacts.forEach(item => item.name = `${item.firstName} ${item.lastName}`);
    contacts = _.uniqBy(contacts, "itsmContactId");
    const itsmSiteContacts = contacts.filter((_contact) => {
      if (_contact.resellerCustomerId && _contact.related_account_ids &&
        _contact.related_account_ids.find(rc => rc === _contact.resellerCustomerId)) {
        return _contact;
      }
    });
    this.itsmSiteContacts = itsmSiteContacts && itsmSiteContacts.length ? itsmSiteContacts : contacts;
    this.filterItsmAddressContactsHelper();
    if (this.enableMultipleCA) {
      if (tmcProjectIndividualPage && tmcProjectIndividualPage.body.data.site.length > 0 &&
        tmcProjectIndividualPage.body.data.site[0].project &&
        tmcProjectIndividualPage.body.data.site[0].project.target_system) {
        let contractAccountData = tmcProjectIndividualPage.body.data.site[0].project.target_system === "pmpsp" ||
          tmcProjectIndividualPage.body.data.site[0].project.target_system === "mimp" ||
          tmcProjectIndividualPage.body.data.site[0].project.target_system === "mpflexr" ||
          tmcProjectIndividualPage.body.data.site[0].project.target_system === "pmps-st" ?
          tmcProjectIndividualPage.body.data.site[0].project.partnerContractAccounts ?
            tmcProjectIndividualPage.body.data.site[0].project.partnerContractAccounts.contract_accounts :
            [] :
          tmcProjectIndividualPage.body.data.site[0].project.customerContractAccounts ?
            tmcProjectIndividualPage.body.data.site[0].project.customerContractAccounts.contract_accounts :
            [];
        contractAccountData = contractAccountData.filter(it => it.status);
        const projectOpportunityId = tmcProjectIndividualPage.body.data.site[0].project.opportunityId;
        this.itsmContractAccount = contractAccountData.map((item) => {
          let contractAcct;
          if (this.enablePOR0241 && projectOpportunityId &&
            !item.contracts.find(contract => contract.opportunityId === projectOpportunityId)) {
            contractAcct = undefined;
          } else {
            contractAcct = {
              name: item.contractAccountName,
              cId: item.contractAccountId,
            };
          }
          return contractAcct;
        }).filter(account => account !== undefined);
      }
    }
  }

  filterItsmAddressContactsHelper() {
    this.settableAddressesWithItsmBuildingIds = this.settableAddresses.filter(it => it.itsmBuildingId);
    this.itsmSiteContactsWithItsmId = this.itsmSiteContacts.filter(it => !!it.itsmContactId);
  }

  async onListControlsChange(event) {
    switch (event["key"]) {
      case "page":
        this.currentPage = event["value"];
        break;
      case "search":
        this.currentPage = DEFAULT_PAGE;
        this.searchText = event["value"];
        break;
      case "limit":
        this.currentPage = DEFAULT_PAGE;
        this.pageSize = event["value"];
        break;
      default:
        console.info(`Unknown ${event["key"]}`);
        break;
    }

    await this.loadData();
  }

  async fileUploaded() {
    await this.clearAndCloseCurrentAsset();
    await this.loadData();
  }

  @handleErrors()
  async remove(asset: AssetForSiteDesignModel) {
    this.processingAsset = true;
    const doRemove = await this.confirmDialogService.confirm(
      "Confirm Removal",
      "Are you sure you want to remove this item?",
    );

    if (!doRemove) {
      this.processingAsset = false;
      return;
    }

    if (this.currentDeviceType === "asset") {
      this.checkDeviceIsAssociated(asset);
      await this.assetService.deleteById(asset.id);
    } else if (this.currentDeviceType === "accessory") {
      await this.accessoryService.deleteAccessory(asset.id);
      if (asset.assetId) this.devicesAssoc[asset.assetId][asset.type] -= 1;
    } else if (this.currentDeviceType === "software") {
      await this.assetService.deleteSoftware(asset.id);
      if (asset.assetId) this.devicesAssoc[asset.assetId][asset.type] -= 1;
    } else {
      await this.assetService.deleteIndependentService(asset.id);
      if (asset.assetId) this.devicesAssoc[asset.assetId][asset.type] -= 1;
    }

    this.selectedIndex = -1;
    await this.loadData();
    this.processingAsset = false;
  }

  checkDeviceIsAssociated(asset: AssetForSiteDesignModel) {
    const association = this.assets.find(a => a.type !== "asset" && a.assetId === asset.id);
    if (association) throw Error("This device is associated with another solution and it can't be deleted.");
  }

  @toggleLoading("processingAsset")
  @handleErrors()
  async save(data: DataFromEditAssetModel) {
    this.successfulSave = false;
    let success;
    if (data.changes) {
      if (this.currentDeviceType === "asset") {
        this.processingAsset = true;
        const errors = this.assetValidations(data.asset, this.showBillFrom,this.enableAssetColorsFlag);
        if (errors.length) {
          const multiError = new MultiError("");
          multiError.errors = errors;
          this.error = multiError;
          this.processingAsset = false;
          return;
        }
        if (data.asset.serialNumber) data.asset.serialNumber = data.asset.serialNumber.toUpperCase().trim();
        const {updated} = await this.assetService.saveAsset(data.asset);
        success = updated;
        this.processingAsset = false;
      } else if (this.currentDeviceType === "accessory") {
        const {updated} = await this.accessoryService.saveAccessory(this.currentAccessory);
        success = updated;
      } else if (this.currentDeviceType === "software") success = await this.saveSoftware();
      else {
        success = await this.saveIndependentService();
      }

      if (success) {
        await this.loadItsmData();
        this.successfulSave = true;
      }
    }

    this.assetChanged = false;
  }

  @handleErrors()
  async saveSoftware() {
    this.processing = true;
    if (!this.currentSoftware.change) return false;
    if (this.currentSoftware.serialNumber) {
      this.currentSoftware.serialNumber = this.currentSoftware.serialNumber.toUpperCase().trim();
    }
    const {updated} = await this.assetService.saveSoftware([
      new SoftwareInputDataGqlModel(this.currentSoftware),
    ]);
    if (updated) {
      // Update the assets array with the new serial number
      if (this.selectedIndex !== undefined && this.assets[this.selectedIndex]) {
        this.assets[this.selectedIndex].serialNumber = this.currentSoftware.serialNumber;
      }
      this.currentSoftware.change = false;
      this.assetChanged = false;
      this.softwareSaved = true;
      // Close the dropdown after successful save
      await this.closeDetails({ 
        asset: this.currentAsset, 
        changes: false 
      });
    }
    this.processing = false;

    return updated;
  }

  @handleErrors()
  async saveIndependentService() {
    this.processing = true;
    if (!this.currentDis.change) return false;
    const {updated} = await this.assetService.saveIndependentService([new DisInputDataGqlModel(this.currentDis)]);
    if (updated) {
      this.currentDis.change = false;
      this.assetChanged = false;
      this.disSaved = true;
      // Close the dropdown after successful save
      await this.closeDetails({
        asset: this.currentAsset,
        changes: false,
      });
    }
    this.processing = false;

    return updated;
  }

  @handleErrors()
  async showContent(index: number, asset: AssetForSiteDesignModel) {
    if (this.selectedIndex === index) return;
    asset.isClicked = true;
    if (this.assetChanged) {
      const result = await this.workflowService.showUnsavedChangesWarning();

      switch (result) {
        case "save":
          await this.save({asset: this.currentAssetChanged, changes: this.assetChanged});
          if (!this.successfulSave) {
            asset.isClicked = false;
            return;
          }
          this.letAddNewAsset = true;
          break;
        case "continue":
          await this.clearAndCloseCurrentAsset();
          this.letAddNewAsset = true;
          break;
        case "cancel":
          this.letAddNewAsset = false;
          asset.isClicked = false;
          return;
        default:
          break;
      }
    }
    this.assetOpened = true;
    await this.setSolutionData(asset);
    this.selectedIndex = index;
    this.letAddNewAsset = true;
    asset.isClicked = false;
  }

  @handleErrors()
  async setSolutionData(asset: AssetForSiteDesignModel) {
    if (asset.type === "asset") {
      this.currentAsset = await this.assetService.getAsset(asset.id);

      const params: any = `
        countryId: country_id
        billFromStructure: bill_from_structure
        `;
      const projectInfo = await this.hasuraGqlService.getProjectResponseFromHasura(this.projectId, params);
      if(!this.enableBillFrom || projectInfo.countryId != 'IN'){
        if(this.currentAsset.software){
          for(let software of this.currentAsset.software){
            delete software['billFromBPIDId'];
          }
        }
      }


      if (this.currentAsset.standaloneAccessories && this.currentAsset.standaloneAccessories.length > 0) {
        this.currentAsset.standaloneAccessories.map((software) => {
          if (!software.contractAccountId && (this.siteContract.length > 0 ||
            this.itsmContractAccount.length === 1)) {
            software.contractAccountId = this.siteContract[0].contractAccountId;
          }
        });
      }
      if (this.currentAsset.software && this.currentAsset.software.length > 0) {
        this.currentAsset.software.map((accessory) => {
          if (!accessory.contractAccountId && (this.siteContract.length > 0 ||
            this.itsmContractAccount.length === 1)) {
            accessory.contractAccountId = this.siteContract[0].contractAccountId;
          }
        });
      }
      if (!this.currentAsset.contractAccountId && (this.siteContract.length > 0 ||
        this.itsmContractAccount.length === 1)) {
        this.currentAsset.contractAccountId = this.siteContract[0].contractAccountId;
      }
      this.currentDevice = await this.currentAsset.availableDevices.find(d => d.id === this.currentAsset.deviceId);
      this.assetAssociations.accessories = this.currentAsset.standaloneAccessories.length;
      this.assetAssociations.software = this.currentAsset.software.length;
    } else if (asset.type === "accessory") {
      this.currentAccessory = await this.accessoryService.getAccessory(asset.id);
      if (!this.currentAccessory.contractAccountId && this.siteContract.length > 0) {
        this.currentAccessory.contractAccountId = this.siteContract[0].contractAccountId;
      }
    } else if (asset.type === "software") {
      this.currentSoftware = await this.assetService.getSoftware(asset.id);
      if (!this.currentSoftware.contractAccountId && this.siteContract.length > 0) {
        this.currentSoftware.contractAccountId = this.siteContract[0].contractAccountId;
      }
    } else {
      this.currentDis = await this.assetService.getIndependentService(asset.id);
      if (!this.currentDis.contractAccountId && this.siteContract.length > 0) {
        this.currentDis.contractAccountId = this.siteContract[0].contractAccountId;
      }
    }
    this.currentDeviceType = asset.type;
  }

  @handleErrors()
  async individualAccessoryChange(data: DataFromEditAccessoryModel) {
    if (data.errors) throw new Error(data.errors);
    this.assetChanged = data.changes;
    if (!data.accessories[0].keep) await this.remove(this.assets[this.selectedIndex]);
    if (this.selectedIndex !== undefined && this.assets[this.selectedIndex]) {
      this.assets[this.selectedIndex].serialNumber = data.accessories[0].serialNumber; // Update in the assets array
    }  
  }

  individualSoftwareChange(data) {
    this.assetChanged = data.changes;
    if (data.changes) this.softwareSaved = false;
  }

  individualDisChange(data) {
    this.assetChanged = data.changes;
    if (data.changes) this.disSaved = false;
  }

  assetValidations(asset: AssetGqlModel, enableBillFrom = false, enablePOR089_2 = false) {
    const assetForValidation: AssetDataValidationModel = {
      installDate: asset.installDate,
      orderDate: asset.orderDate,
      initialPageCountColor: asset.initialPageCountColor,
      initialPageCountColorProfessional: asset.initialPageCountColorProfessional,
      initialPageCount: asset.initialPageCount,
      billFromBPIDId: asset.billFromBPIDId,
      initialPageCountColorGeneralOffice: asset.initialPageCountColorGeneralOffice,
      initialPageCountColorAccent: asset.initialPageCountColorAccent,
      initialPageCountOther: asset.initialPageCountOther,
      printCapability: asset.printCapability,

    };

    return this.assetService.assetDataValidations(assetForValidation, enableBillFrom, enablePOR089_2);
  }

  async currentAssetChangeDetected(data: DataFromEditAssetModel) {
    const accessoriesAssociationChange = this.assetAssociations.accessories !== data.asset.standaloneAccessories.length;
    const softwareAssociationChange = this.assetAssociations.software !== data.asset.software.length;

    if (accessoriesAssociationChange || softwareAssociationChange) {
      this.checkSolutionsAssociationChanges(data.asset, accessoriesAssociationChange);
    }

    this.currentAssetChanged = new AssetGqlModel(data.asset);
    this.assetChanged = data.changes;
  }

  checkSolutionsAssociationChanges(asset: AssetGqlModel, accessories: boolean) {
    this.assetAssociations.accessories = asset.standaloneAccessories.length;
    this.assetAssociations.software = asset.software.length;

    const solution = accessories ? "accessory" : "software";
    const solutionsIds = accessories ?
      asset.standaloneAccessories.reduce((acc, it) => {
        acc[it.id] = "0";
        return acc;
      }, {}) :
      asset.software.reduce((so, it) => {
        so[it.id] = "0";
        return so;
      }, {});

    this.assets.forEach((a) => {
      if (a.type === solution) {
        if (!a.assetId && solutionsIds[a.id]) {
          a.assetAssociatedName = this.assets[this.selectedIndex].description;
          a.assetId = asset.id;
          this.setDeviceAssociation(a);
        } else if (a.assetId === asset.id && !solutionsIds[a.id]) {
          if (this.devicesAssoc[a.assetId][a.type] > 0) this.devicesAssoc[a.assetId][a.type] -= 1;
          a.assetAssociatedName = null;
          a.assetId = null;
        }
      }
    });
  }

  setDeviceAssociation(solution: AssetForSiteDesignModel) {
    if (!this.devicesAssoc[solution.assetId]) {
      this.devicesAssoc[solution.assetId] = {[solution.type]: 1};
    } else if (!this.devicesAssoc[solution.assetId][solution.type]) {
      this.devicesAssoc[solution.assetId][solution.type] = 1;
    } else this.devicesAssoc[solution.assetId][solution.type] += 1;
  }

  async showImportCdfDialog() {
    ImportCdfDialogComponent.showImportCdfModal(this.dialogService, {
      projectId: this.projectId,
      siteId: this.siteId,
    })
      .subscribe(() => {
        this.loadData();
      });
  }

  showDartCorrectionDialog() {
    return DartCorrectionRequestDialogComponent.showDialogModal(
      this.dialogService,
      {projectId: this.projectId},
    );
  }

  async showAddIndividualAssetDialog(type: string) {
    const selectedAsset = this.assets[this.selectedIndex];
    if (selectedAsset) {
      await this.closeDetails({
        asset: selectedAsset.type === "asset" ? this.currentAsset : new AssetGqlModel(selectedAsset),
        changes: this.assetChanged,
      });
    }
    if (this.letAddNewAsset) {
      AddIndividualAssetsDialogComponent.showAddIndividualAssetModal(this.dialogService, {
        projectId: this.projectId,
        targetId: this.targetId,
        assetType: type,
      })
        .subscribe(() => {
          this.loadData();
        });
    }
  }

  async associateAsset(solution: AssetForSiteDesignModel, index: number) {
    const availableAssets = this.assets.filter(a => a.type === "asset");

    const selectedAsset = await this.dialogService.showDialog(
      SelectAssetAssociationDialogComponent,
      {
        typeModal: solution.type,
        siteId: this.siteId,
        solution,
        assets: availableAssets,
      },
    );
    if (selectedAsset.success && selectedAsset.data) {
      const previousDeviceAssocId = solution.assetId;
      this.assets[index].assetId = selectedAsset.data.id;
      this.assets[index].assetAssociatedName = selectedAsset.data.description;

      if (selectedAsset.data.id !== previousDeviceAssocId) {
        const {type, id} = this.assets[index];

        if (selectedAsset.data.id) {
          this.setDeviceAssociation(this.assets[index]);
          if (this.assetOpened && type === "accessory") {
            this.currentAsset.standaloneAccessories.push(new StandaloneAccessoryGqlModel(this.assets[index]));
          }
          if (this.assetOpened && type === "software") {
            this.currentAsset.software.push(new SoftwareInputDataGqlModel(this.assets[index]));
          }
        }

        if (previousDeviceAssocId) {
          this.devicesAssoc[previousDeviceAssocId][solution.type] -= 1;
          if (this.assetOpened && type === "accessory") {
            this.currentAsset.standaloneAccessories =
              this.currentAsset.standaloneAccessories.filter(it => it.id !== id);
          }
          if (this.assetOpened && type === "software") {
            this.currentAsset.software = this.currentAsset.software.filter(it => it.id !== id);
          }
        }
      }
    }
  }

  async closeDetails(data: DataFromEditAssetModel) {
    if (data.changes) {
      const result = await this.workflowService.showUnsavedChangesWarning();

      switch (result) {
        case "save":
          await this.save(data);
          this.selectedIndex = -1;
          this.letAddNewAsset = true;
          break;
        case "continue":
          await this.clearAndCloseCurrentAsset();
          this.letAddNewAsset = true;
          break;
        case "cancel":
          this.letAddNewAsset = false;
          break;
        default:
          break;
      }
    } else {
      await this.clearAndCloseCurrentAsset();
      this.letAddNewAsset = true;
    }
  }

  checkDirty(): boolean {
    return this.assetChanged;
  }

  async clearAndCloseCurrentAsset() {
    this.assetOpened = false;
    this.assetChanged = false;
    this.selectedIndex = -1;
    this.currentAsset = new AssetGqlModel({});
    this.currentDevice = new AssetAvailableDeviceModel({});
    this.currentAccessory = new StandaloneAccessoryGqlModel({});
    this.currentSoftware = new SoftwareGqlModel({});
    this.currentDis = new DisGqlModel({});
    this.currentDeviceType = "";
    this.softwareSaved = false;
    this.disSaved = false;
    this.assetAssociations.accessories = 0;
    this.assetAssociations.software = 0;
  }

  setFileDownload(evt) {
    this.isFileDownloading = evt;
  }

  private async loadBillFromBuildings() {
    this.billFromAccounts = await this.billFromService.getBillFromBuildings(
      this.projectId,
      this.project.country.countryId,
    );
  }

  async loadFinancialContact() {
    this.POR954_TMC = await this.appSettingsService.getFeaturePermission("POR954_TMC", this.projectId);
    if(this.POR954_TMC) {
      await this.projectService.getItsmContacts(this.projectId, false, true);

    }

    const params: any = {
      projectId: this.projectId,
      uiAction: "PROJECT-CONTACT",
      queryType: "Contact",
    };

    if (this.targetSystem === "pmpsp" || this.targetSystem === "mimp" ||
    this.targetSystem === "mpflexr" || this.targetSystem === TARGET_SYSTEM.PMPS_SELL_THROUGH ||
    this.targetSystem === TARGET_SYSTEM.PMPS_BILL_THROUGH) {
      params.query = this.POR954_TMC ? Query.PARTNER_CONTACTS_WITH_ACTIVE_FILTER : Query.PARTNER_CONTACTS;
    } else {
      params.query = this.POR954_TMC ? Query.CUSTOMER_CONTACTS_WITH_ACTIVE_FILTER : Query.CUSTOMER_CONTACTS;
    }
    const contactResponse = await this.hasuraGqlService.getResponseFromHasura(params);

    const contacts = contactResponse && contactResponse.body && contactResponse.body.data &&
      contactResponse.body.data.contacts && contactResponse.body.data.contacts.length > 0 ?
      contactResponse.body.data.contacts : [];
    if (this.targetSystem === TARGET_SYSTEM.PMPS_BILL_THROUGH) await this.getHpInvoiceContact(contacts);
   this.setItsmContacts(contacts);
    return this.itsmContacts;
  }
  setItsmContacts(contacts) {
    if (contacts.length) {
      contacts.forEach(contact => contact.name = `${contact.firstName} ${contact.lastName}`);
      this.itsmContacts = contacts;
      this.itsmContactsWithItsmIds = this.itsmContacts.filter(it => it.itsmContactId);
      this.itsmContactsWithBpId = contacts.filter(it => it.businessPartnerId);
      this.nonHpItsmContactsWithBpId = this.itsmContactsWithBpId.filter(it => !it.isHpContact);
      this.itsmContactsWithBpIdMap =
        this.itsmContactsWithBpId.reduce((acc, it) => { acc[it.id] = it; return acc; }, {});
      this.buildContactTypes();
    }
  }

  buildContactTypes() {
    for (const contact of this.itsmContactsWithBpId) {
      if (!contact.isHpContact) {
        this.ContractualContactTypes.billTo.push(contact);
        this.ContractualContactTypes.invoice.push(contact);
      } else if (contact.contactTypes) {
        Object.keys(contact.contactTypes).forEach((type) => {
          if (type !== "billTo" && type !== "invoice" && this.ContractualContactTypes[type]) {
            this.ContractualContactTypes[type].push(contact);
          }
        });
      }
    }

    const contactTypesArray = Object.keys(this.ContractualContactTypes);
    for (const type of contactTypesArray) {
      if (!this.ContractualContactTypes[type].length && (type === "billTo" || type === "invoice")) {
        this.ContractualContactTypes[type] = this.nonHpItsmContactsWithBpId;
      } else if (!this.POR954_TMC && !this.ContractualContactTypes[type].length) this.ContractualContactTypes[type] = this.itsmContactsWithBpId;
    }
  }
  async getHpInvoiceContact(contacts) {
    const params: any = {
      projectId: this.projectId,
      uiAction: "PROJECT-CONTACT",
      queryType: "Contact",
      query: Query.CUSTOMER_CONTACTS,
    };
    const contactResponse = await this.hasuraGqlService.getResponseFromHasura(params);
    contacts.forEach((itm) => {
      if (itm.contactTypes && itm.contactTypes["hpInvoice"] === true) {
        itm.contactTypes["hpInvoice"] = false;
      }
    });
    const customerContacts = contactResponse && contactResponse.body && contactResponse.body.data &&
      contactResponse.body.data.contacts && contactResponse.body.data.contacts.length > 0 ?
      contactResponse.body.data.contacts : [];
    customerContacts.forEach((contact) => {
      if (contact.contactTypes && contact.contactTypes["hpInvoice"] === true) contacts.push(contact);
    });
  }
}
